<template>
    <div>
        <el-form ref="form"
                 :model="form"
                 label-width="120px"
                 @submit.prevent.native="onSubmit">
            <el-row :gutter="30">
                <el-col :span="19">
                    <div class="box">
                        <div class="box__header">
                            <span class="box__header--text">{{ getRouteName($route) }}</span>
                            <form-language-switcher></form-language-switcher>
                        </div>

                        <el-form-item label="Nazwa robocza"
                                      :error="errors['working_name']"
                                      required>
                            <el-input v-model="form['working_name']"></el-input>
                        </el-form-item>
                        <div class="slides">
                            <el-collapse class="formset__list">
                                <div v-for="slide, i in form.slides" class="formset__item">
                                    <el-collapse-item :name="i">
                                        <template slot="title">
                                            <formset-header :label="`${slide.title_pl || 'Nowy slajd'}`"
                                                            :errors="checkForErrors(errors.slides, [i])"
                                                            :items.sync="form.slides"
                                                            :index="i"/>
                                        </template>
                                        <el-form-item label="Wyświetlaj grafikę na całym slajdzie"
                                                      :error="errors.slides && errors.slides[i] && errors.slides[i]['media_on_whole_slide']">
                                            <el-switch v-model="slide['media_on_whole_slide']"/>
                                        </el-form-item>
                                        <div class="inline-form-group"
                                             v-show="!slide['media_on_whole_slide']">
                                            <el-form-item label="Tytuł"
                                                          :error="errors.slides && errors.slides[i] && errors.slides[i][addLanguageSuffix('title')]">
                                                <el-input v-model="slide[addLanguageSuffix('title')]"
                                                          :disabled="slide['media_on_whole_slide']"/>
                                            </el-form-item>
                                        </div>
                                        <div class="inline-form-group">
                                            <el-form-item label="Kolor tła"
                                                          :error="errors.slides && errors.slides[i] && errors.slides[i]['bg_color']">
                                                <el-color-picker v-model="slide.bg_color"/>
                                            </el-form-item>
                                            <el-form-item label="Kolor tekstu"
                                                          v-show="!slide['media_on_whole_slide']"
                                                          :error="errors.slides && errors.slides[i] && errors.slides[i]['text_color']">
                                                <el-color-picker v-model="slide.text_color"/>
                                            </el-form-item>
                                        </div>
                                        <div class="inline-form-group"
                                             v-show="!slide['media_on_whole_slide']">
                                            <el-form-item label="Podtytuł"
                                                          :error="errors.slides && errors.slides[i] && errors.slides[i][addLanguageSuffix('subtitle')]">
                                                <wyswig-input v-model="slide[addLanguageSuffix('subtitle')]"
                                                              :simple="true"/>
                                            </el-form-item>
                                        </div>
                                        <el-form-item label="źródło iframe (domyślnie na całym slajdzie)"
                                                      :error="errors.slides && errors.slides[i] && errors.slides[i].iframe">
                                            <el-input placeholder="https://player.vimeo.com/video/278003111?autoplay=1&muted=1"
                                                      v-model="slide.iframe"/>
                                        </el-form-item>
                                        <div class="inline-form-group">
                                            <el-form-item label="Grafika"
                                                          :error="errors.slides && errors.slides[i] && errors.slides[i]['image']">
                                                <image-input-component v-model="slide.image"/>
                                            </el-form-item>
                                            <el-form-item label="URL do filmu"
                                                          :error="errors.slides && errors.slides[i] && errors.slides[i]['video']">
                                                <el-input v-model="slide['video']"
                                                          placeholder="https://www.youtube.com/watch?v=blJKoXWlqJk"/>
                                            </el-form-item>
                                        </div>
                                        <el-form-item label="Przycisk"
                                                      v-show="!slide['media_on_whole_slide']">
                                            <el-form-item label="Ukryj przycisk">
                                                <el-switch :disabled="slide.media_on_whole_slide"
                                                           v-model="slide.hide_button"/>
                                            </el-form-item>
                                            <el-form-item label="Nazwa"
                                                          v-if="!slide.hide_button"
                                                          :error="errors.slides && errors.slides[i] && errors.slides[i]['button_title']">
                                                <el-input v-model="slide[addLanguageSuffix('button_title')]"
                                                          :disabled="slide.hide_button"/>
                                            </el-form-item>
                                            <link-component v-model="slide.button_link"
                                                            v-if="!slide.hide_button"
                                                            :errors="errors.slides && errors.slides[i] && errors.slides[i]['button_link']">
                                            </link-component>
                                        </el-form-item>
                                    </el-collapse-item>
                                </div>
                            </el-collapse>
                            <el-button @click="addSlide"
                                       class="fluid"
                                       type="primary">
                                Dodaj slajd
                            </el-button>
                        </div>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="box">
                        <div class="box__header">
                            {{ $t('manage') }}
                        </div>
                        <el-form-item class="form__buttons" label-width="0">
                            <router-link :to="redirectRoute">
                                <el-button class="fluid form__button">{{ $t('cancel') }}</el-button>
                            </router-link>
                            <el-button @click="onSubmit"
                                       type="primary"
                                       class="fluid form__button"
                                       :loading="loading">
                                {{ $t('submit') }}
                            </el-button>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
    import {Popup} from '@/api/';

    export default {
        data () {
            return {
                loading: false,
                redirectRoute: {name: 'Popups List'},
                form: {
                    slides: []
                },
                errors: {},
                service: Popup
            }
        },
        mounted () {
            this.fetchData()
        },
        methods: {
            fetchData () {
                if (this.$route.params.id) {
                    this.service.get(this.$route.params.id).then(response => {
                        this.form = response.data
                    })
                }
            },
            toggleLink (slide) {
                slide.button_link = slide.button_link == null ? {} : null
            },
            onSubmit () {
                this.loading = true;
                const payload = {...this.form}

                // clean unnecessary fields if media_on_whole_slide chosen
                const fields_to_delete = [
                    'title_pl', 'subtitle_pl', 'title_en', 'subtitle_en', 'hide_button',
                    'button_title_pl', 'button_title_en', 'button_link'
                ]

                payload.slides.forEach(slide => {
                    if (slide.media_on_whole_slide) {
                        fields_to_delete.forEach(field => {
                            delete slide[field]
                        })
                    }
                })

                const id = this.$route.params.id
                const service = id ? this.service.update(id, payload) : this.service.save(payload)
                service
                    .then(this.successHandler)
                    .catch(this.errorHandler)
            },
            addSlide () {
                const blankObject = {}
                if (!Array.isArray(this.form.slides)) {
                    this.form.slides = [
                        blankObject
                    ]
                } else {
                    this.form.slides.push(blankObject)
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// PopupForm.vue?40ee64dd